const BASE_KEY = 'recovery.snapshots.v1';
const MAX_SNAPSHOTS = 25;

function safeJsonParse(text, fallback) {
  try {
    return JSON.parse(text);
  } catch {
    return fallback;
  }
}

function keyForProject(projectId) {
  const p = (projectId || '').toString().trim();
  return p ? `${BASE_KEY}.${p}` : BASE_KEY;
}

export function listRecoverySnapshots({ projectId } = {}) {
  const raw = localStorage.getItem(keyForProject(projectId));
  const arr = safeJsonParse(raw || '[]', []);
  return Array.isArray(arr) ? arr : [];
}

export function addRecoverySnapshot({ projectId, type, label, data }) {
  const snapshot = {
    id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    at: new Date().toISOString(),
    type: (type || 'unknown').toString(),
    label: (label || '').toString(),
    data,
  };

  const next = [snapshot, ...listRecoverySnapshots({ projectId })].slice(0, MAX_SNAPSHOTS);
  localStorage.setItem(keyForProject(projectId), JSON.stringify(next));
  return snapshot;
}

